import styled from 'styled-components'

export const FormGroup = styled.div`
    margin-bottom: 30px;
`

export const GroupTitle = styled.h3`
    color: #333;
    margin: 20px 0 12px 0;
`

export const CenterItem = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 40px;
`

export const FixedLoading = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;

`